import { render, staticRenderFns } from "./MetaDate.vue?vue&type=template&id=054e9e02"
import script from "./MetaDate.vue?vue&type=script&lang=js"
export * from "./MetaDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports